export default {
	sidebar: {
		dashboard: 'Dashboard',
		shop: 'Shop',
		articles: 'Articles',
		cart: 'Shopping Cart',
		orders: 'Orders',
		//
		delivery: 'Delivery',
		locations: 'Locations',
		//
		seller_header: 'Seller',
		seller_articles: 'Articles',
		seller_orders: 'Orders',
		seller_order_items: 'Order Items',
		seller_delivery: 'Delivery',
		seller_map: 'Map',
		//
		event_header: 'Event',
		event_articles: 'Articles',
		event_orders: 'Orders',
		event_order_items: 'Order Items',
		event_delivery: 'Delivery',
		event_map: 'Map',
		//
		settings_header: 'Settings',
		admin_header: 'Administration',
		event_settings: '{event_name}',
		team_settings: '{team_name}',
		//
		no_event_selected: 'No event selected',
		no_team_selected: 'No team selected',
	},
	// Short titles (tooltips) for buttons without a visible label, mainly for the actions
	// inside the tables. Only a few words, so it is clear what the button does.
	buttons: {
		article: {
			create: 'Create article',
			copy: 'Copy article',
			edit: 'Edit article',
			show: 'Show article',
			delete: 'Delete article',
			open: 'Open article',
			release: 'Release for review',
			release_info: 'Why no release?',
			accept: 'Release for ordering',
			add_dependent: 'Add dependent article',
			remove_dependent: 'Remove dependent article',
			add_file: 'Add file',
			remove_file: 'Remove file',
		},
		article_category: {
			create: 'Create category',
			delete: 'Delete category',
		},
		order: {
			create: 'Create order',
			edit: 'Edit order',
			show: 'Show order',
			delete: 'Delete order',
			open: 'Open order',
			shop: 'To the shop',
			cart: 'To the shopping cart',
		},
		order_item: {
			list: 'To the order items',
			create: 'Add item',
			price: 'Enter price',
			confirm: 'Confirm item',
			edit: 'Edit item',
			switch: 'Switch article',
			refuse: 'Refuse item',
			accept_price: 'Accept price',
			deliver: 'Mark as delivered',
			increase: 'Increase amount',
			decrease: 'Decrease amount',
			delete: 'Delete item',
			mail: 'E-mail to the orderer',
		},
		location: {
			create: 'Create location',
			edit: 'Edit location',
			delete: 'Delete location',
			orders: 'Orders of the location',
		},
		team: {
			delete: 'Remove team',
			orders: 'Orders of the team',
			delivery_note: 'Show delivery note',
		},
		file: {
			show: 'Show file',
			download: 'Download file',
		},
		map: {
			download: 'Download map',
		},
	},
	pages: {
		articles: {
			title: 'Articles',
		},
		article_settings: {
			published_info:
				'The article is released for review. To change it, deactivate the release in the article overview.',
			accepted_info: 'The article is released for ordering. It can no longer be edited.',
		},
		dashboard: {
			title: 'Welcome to Event Order Pro',
			show_days: 'Event period',
			production_days: 'Production period',
			order_days: 'Ordering period',
			text: 'Here you can order what your team needs for the event.',
			shipping_address: 'Delivery address:',
			buttons: {
				to_shop: 'To the shop',
				to_articles: 'To the offered articles',
				new_article: 'Create a new article now',
			},
			todos: {
				title: 'My tasks',
				no_todos: 'No open tasks',
				no_todos_hint: 'There is nothing for you to do right now.',
				articles_to_accept: 'Articles that still have to be accepted:',
				articles_to_publish: 'Articles that still have to be published:',
				price_to_set: 'Prices that still have to be set:',
				price_to_accept: 'Prices that still have to be accepted:',
				cart_items_to_confirm: 'Cart items that still have to be confirmed:',
			},
		},
		shop: {
			ordering_start_at: 'Ordering opens on {date}.',
			ordering_end_at: 'Ordering is possible until {date}.',
			ordering_expired: 'Orders are no longer possible. Please get in touch with your contact person.',
		},
		cart: {
			title: 'Shopping Cart',
			id: 'Id',
		},
		orders: {
			title: 'Order of  {team}',
		},
		delivery: {
			title: 'Delivery of {team}',
		},
		order_review: {
			title: 'Order: {name}',
		},
		event: {
			orders: {
				title: 'Orders - {event}',
			},
			order_items: {
				title: 'Order Items - {event}',
			},
			delivery: {
				title: 'Delivery - {event}',
			},
		},
		seller: {
			articles: {
				title: 'Articles',
				add: 'Add new article',
				edit: 'Edit article',
				delete: 'Delete article',
				delete_confirm: 'Do you really want to delete this article?',
			},
			orders: {
				title: 'Orders at {team}',
			},
			order_items: {
				title: 'Order items at {team}',
			},
			delivery: {
				title: 'Delivery of order items by {team}',
			},
		},
		admin_settings: {
			article_categories: {
				title: 'Article Categories',
			},
		},
		event_settings: {
			title: 'Event settings',
			general: {
				address_data: 'Address data',
			},
			users: {
				title: 'People',
				add: 'Add new person',
			},
			teams: {
				title: 'Teams',
				add: 'Add new team',
				delivery_note: 'Show delivery note',
			},
			locations: {
				title: 'Locations',
				add: 'Add new location',
			},
			delivery_note: {
				title: 'Delivery note design',
				hint: 'The sender address comes from the general settings of the event, the recipient address from the master data of the team. The delivery note lists all delivered order items of a team.',
			},
			import: {
				title: 'Import',
				heading: 'Team import',
				intro: 'Create teams, team admins and locations from an Excel or CSV file.',
				open: 'Import file',
				file: {
					hint: 'Excel or CSV file with one stand unit per row. The first row must contain the column headers.',
				},
				mapping: {
					no_admin_email: 'Without a mapped e-mail address the team is created, but no team admin.',
				},
				block: {
					team: 'Team with master data',
					admin: 'Create team admin',
				},
				report: {
					admin: 'Team admin',
				},
				field: {
					external_id: 'Unique stand unit ID',
					team_name: 'Company (team)',
					team_number: 'Team number',
					legal_name: 'Legal name',
					street: 'Street',
					street_number: 'Street number',
					zip: 'Postal code',
					city: 'City',
					country: 'Country',
					vat_number: 'VAT number',
					tax_number: 'Tax number',
					invoice_note: 'Invoice note',
					contact_mobile: 'Mobile (contact)',
					admin_firstname: 'Team admin: first name',
					admin_lastname: 'Team admin: last name',
					admin_email: 'Team admin: e-mail',
				},
				subject: {
					team: 'Team',
					invitation: 'Invitation',
					admin: 'Admin',
				},
				summary: {
					teams_created: 'Teams new',
					teams_updated: 'Teams updated',
					invitations_created: 'Invitations',
					invitations_updated: 'Invitations updated',
					admins_created: 'Admins new',
					admins_attached: 'Admins linked',
					admins_skipped: 'Admins skipped',
				},
				error: {
					missing_team_name: 'No company',
				},
				warning: {
					missing_admin_email: 'No e-mail – no admin',
					invalid_admin_email: 'Invalid e-mail',
					incomplete_admin_name: 'First or last name is missing',
				},
			},
			locations_import: {
				title: 'Location import',
				heading: 'Location import',
				intro: 'Create or update event locations from a CSV file and assign them to a team.',
				open: 'Import locations',
				file: {
					hint: 'CSV or Excel file with one location per row. The first row must contain the column headers.',
				},
				no_team_hint: 'Without a mapped team number, locations are created but not assigned to a team.',
				option: {
					prefix_external_id: 'Add the external ID to the name',
					prefix_external_id_hint: 'Prepends the external ID to each name so duplicate names become unique.',
					only_matched_teams: 'Only import locations with a matched team',
					only_matched_teams_hint: 'Rows whose team number matches no team are skipped.',
				},
				field: {
					external_id: 'Location external ID',
					name: 'Location name',
					description: 'Description',
					team_number: 'Team number (ID Ausstellende)',
					team_name: 'Assigned team',
				},
				subject: {
					location: 'Location',
					assignment: 'Assignment',
				},
				summary: {
					locations_created: 'Locations new',
					locations_updated: 'Locations updated',
					assignments_created: 'Assignments',
				},
				error: {
					name_taken: 'Name already used',
					team_not_matched: 'No matching team',
				},
				warning: {
					team_not_found: 'Team not found',
					team_ambiguous: 'Team number ambiguous',
				},
			},
		},
	},
	modals: {
		create_cart: {
			title: 'Create new shopping cart',
			select_existing: 'Select existing cart',
		},
		upload_article_file: {
			title: 'Select file',
		},
		delete_cart: {
			title: 'Delete order',
			text: "Do you really want to delete the order '{item}'?",
		},
		edit_order: {
			edit: 'Edit Order',
		},
		edit_article: {
			create: 'Create new Article for {event_name}',
			edit: 'Edit Article for {event_name}',
			name_duplicate: 'The article name is already in use for this event. Please choose another name.',
		},
		edit_article_category: {
			create: 'Create new article category',
			edit: 'Edit article category',
		},
		delete_article_category: {
			title: 'Delete article category',
			text: "Do you really want to delete the article category '{item}'?",
			blocked: 'The category cannot be deleted while articles are assigned.',
		},
		edit_location: {
			create: 'Create new Location for {event_name}',
			edit: 'Edit Location for {event_name}',
		},
		delete_location: {
			title: 'Delete location',
			text: "Do you really want to delete the location '{item}'?",
			blocked: 'The location cannot be deleted while orders are assigned or the event is locked.',
		},
		invite_team: {
			create: 'Invite team to the event',
			edit: 'Adjust the invitation of the team',
			number: 'Reference',
			is_seller: 'Is a seller',
			locations: 'Locations',
			budget_enabled: 'Limit the budget',
			budget: 'Budget',
			custom_ordering_enabled: 'Enable an individual ordering period',
			ordering_start_at: 'Ordering start',
			ordering_start_end: 'Ordering deadline',
			custom_article_categories_enabled: 'Restrict the available article categories',
			article_categories: 'Article categories',
		},
		remove_team: {
			title: 'Remove team',
			text: "Do you really want to remove the team '{item}' from the event?",
		},
		article_order_description: {
			title: 'Order information',
		},
		edit_cart_item_pricing: {
			title: 'Edit the price on request',
		},
		confirm_cart_item: {
			title: 'Confirm cart item',
			text: 'Confirm this cart item? This cannot be undone.',
			ordered: {
				from: 'Required on',
				until: 'Required until',
				quantity_unit: 'Amount',
				quantity_factor: 'Factor',
				total_price: 'Price',
			},
			confirmed: {
				from: 'Confirmed from',
				until: 'Confirmed until',
				quantity_unit: 'Confirmed amount',
				quantity_factor: 'Confirmed factor',
				total_price: 'Price after confirmation',
			},
		},
		switch_cart_item: {
			title: 'Switch the article of the cart item',
			text: 'Switch the article of this cart item? This cannot be undone.',
			switch_team_warning:
				'Careful: the article belongs to another team, after the switch you lose access to the cart item.',
			current_article: 'Current article',
			new_article: 'New article',
		},
		add_cart_item: {
			title: 'Add article to the shopping cart',
			text: 'Add the following article to the shopping cart? The orderer still has to accept the article afterwards.',
		},
	},
	data: {
		article: {
			id: 'Id',
			name: 'Articlename',
			url: 'URL',
			unit: 'Unit',
			factor: 'Factor',
			factor_min: 'Minimum Duration',
			is_pickup: 'Self Pick Up',
			is_shown: 'Shown in Shop',
			is_individual: 'as Multiple Positions in the Shop',
			has_fixed_pricing: 'Pricing',
			cost: 'Purchase Price',
			additional_cost: 'Additional Cost',
			total_cost: 'Total Cost',
			price: 'Price in €',
			price_last_minute: 'Selling Price for Subsequent Booking',
			is_limited_in_time: 'Individual Time Specification',
			available_from: 'Available from',
			available_until: 'Available until',
			brief_description: 'Short Description',
			description: 'Description',
			category: 'Category',
			article_category: 'Category',
			subcategory: 'Subcategory',
			module: 'Module',
			seller: 'Seller',
			team_id: 'Seller',
			image: 'Image',
			ordered_sum: '# Order Sum',
			offered_by_id: 'Offered By',
			dependent_articles: 'Dependent Articles',
			order_notification: 'Message when Adding to Shopping Cart',
			order_description: 'Request for Order Information',
			files: 'Files',
			image_upload_text: 'Upload new Article Image',
			show_file_upload: 'Enable file upload',
		},
		article_categories: {
			id: 'Id',
			name: 'Name',
			articles_count: '# Articles',
			description: 'Description',
		},
		cart: {
			id: 'ID',
			name: 'Order Name*',
			location: 'Location*',
			required_from: 'Order required from*',
			required_until: 'Order required until*',
			company: 'Company',
			firstname: 'Firstname*',
			lastname: 'Lastname*',
			email: 'E-Mail*',
			mobilenumber: 'Mobilenumber*',
			user_id: 'User ID',
			created_at: 'Created at',
			created_by_user_id: 'Created by',

			total_price: 'Total Price',
			order_status: 'Order Status',
			ordered_at: 'Order Date',
			user_avatar: '',
			user_name: 'User',
			team_name: 'Team',
			location_id: 'Location',

			orderdetails: 'Order Details',
			contactperson: 'Contact Person On-site',
			articleoverview: 'Article Overview',

			pos: 'Pos.',
			articlename: 'Articlename',
			amount: 'Amount',
			item_price: 'Unit Price',
			price: 'Price',
			factor: 'Factor',

			order_now: 'Order Now',
			required_from_until: 'Period of use',
			state: 'Status',
			order_progress: 'Order confirmations',
			delivery_progress: 'Delivery status',
			ordered_by_user_id: 'Orderer',
			offered_by_id: 'Offered by',
			team_id: 'Team',
			total_confirmed_price: 'Confirmed total',
		},
		cartItem: {
			id: 'Id',
			name: 'Articlename',
			required_from: 'Required from',
			required_until: 'Required until',
			quantity_unit: 'Amount',
			quantity_factor: 'Factor',
			price: 'Unit Price',
			total_price: 'Price',
			order_description: 'Order information',
			state: 'Status',
			refused_reason: 'Reason for the refusal',
			refused_message: 'Message to the orderer',
			delivered_at: 'Delivered at',
			delivered_message: 'Delivery note',
		},
		location: {
			id: 'Id',
			name: 'Name',
			external_id: 'External Id',
			description: 'Description',
			carts_count: '# Orders',
			teams_count: '# Teams',
			coordinates: 'Coordinates',
		},
		team: {
			pivot: { number: 'Reference', is_seller: 'Seller', budget: 'Budget' },
			legal_name: 'Legal name',
			street: 'Street',
			street_number: 'Street number',
			zip: 'Postal code',
			city: 'City',
			country: 'Country',
			vat_number: 'VAT number',
			tax_number: 'Tax number',
			contact_mobile: 'Mobile (contact)',
			articles_count: '# Offered articles',
			carts_count: '# Outgoing orders',
			locations_count: '# Locations',
			cost_sum: 'Purchase price',
			gross_sum: 'Billing',
		},
		event: {
			ordering_start_at: 'Ordering start',
			ordering_end_at: 'Ordering deadline',
			company_name: 'Company name',
			street: 'Street',
			street_number: 'Street number',
			postalcode: 'Postal code',
			city: 'City',
			delivery_note_intro: 'Introduction text',
			delivery_note_footer: 'Footer',
			delivery_note_show_prices: 'Show prices',
			delivery_note_show_signature: 'Show signature fields',
		},
		event_team_pivot: {
			budget: 'Budget',
			custom_ordering: 'Individual ordering period',
			custom_article_categories: 'Restricted article categories',
		},
	},
	enums: {
		article_fixed_pricing: {
			true: 'Calculated in the shop',
			false: 'Price on request',
		},
		article_unit: {
			null: '',
			piece: 'Piece',
			pack: 'Pack',
			person: 'Person',
			area_qm: 'm²',
			undefined: '?',
		},
		article_factor: {
			null: '',
			event: 'Event',
			day: 'Day',
			hour: 'Hour',
			undefined: '?',
		},
		article_dependency_mode: {
			once: 'Article needed once',
			each: 'Article needed per piece',
		},
		order_state: {
			open: 'Open',
			ordered: 'Ordered',
		},
		cart_item_refused_reason: {
			availability: 'The item is no longer available',
			feasibility: 'It cannot be realized',
			responsibility: 'We are not responsible for this item',
			others: 'Other reasons',
		},
		// The names of the states from @/utils/cartItemState, short enough for the legend below the table
		cart_item_state: {
			open: 'Open',
			waiting_for_price: 'Waiting for the price',
			waiting_for_seller: 'Price to be accepted',
			confirmed: 'Confirmed',
			partially_confirmed: 'Changed and confirmed',
			canceled: 'Canceled',
		},
		cart_item_delivery_state: {
			open: 'Not delivered yet',
			delivered: 'Delivered',
		},
	},
	tabs: {
		order_review: {
			review: 'Order Review',
			notes: 'Notes',
		},
		article_settings: {
			general: 'General',
			preview: 'Preview',
			orders: 'Orders',
			order_items: 'Order Items',
			notes: 'Notes',
		},
		admin_settings: {
			article_categories: 'Article Categories',
			groups: {
				shop: 'Shop',
			},
		},
		team_settings: {
			general: 'General',
		},
		event_settings: {
			general: 'General',
			announcements: 'Announcements',
			users: 'Users',
			teams: 'Teams',
			locations: 'Locations',
			delivery_note: 'Delivery note',
			import: 'Import',
		},
	},
	popovers: {
		order_state: {
			open: {
				title: 'Order in the shopping cart',
				text: 'The order has not been placed yet. The articles are still in the shopping cart.',
			},
			ordered: {
				title: 'Order placed',
				text: 'The order has been placed. The articles are booked.',
			},
		},
		article: {
			is_pickup: {
				title: 'Self pick up',
				text: 'States whether the article is provided directly at the location of the event, or whether it has to be picked up at a central point (helpdesk or festival office).',
			},
			is_shown: {
				title: 'Show in the shop',
				text: 'States whether the article is shown to the orderers in the shop right away, or whether it is created hidden so the seller can add it to an order when needed. This setting is also required for "dependent articles".',
			},
			is_individual: {
				title: 'As several items in the shopping cart',
				text: 'States whether the article is added to the shopping cart as one item with an amount, or as several individual items. That can make sense for special requests or for articles with an individual period.',
			},
			has_fixed_pricing: {
				title: 'Pricing',
				text: 'States whether the price is calculated in the shop right away, or whether it is calculated on request after the order.',
			},
			cost: {
				title: 'Purchase price',
				text: 'Enter the amount the article costs the organizer here.',
			},
			additional_cost: {
				title: 'Additional cost',
				text: 'Enter the additional external cost of the article here, e.g. delivery cost.',
			},
			price: {
				title: 'Selling price',
				text: 'Enter the amount the article is offered for at the event including the margin (at least 20%, to be agreed with the organizer).',
			},
			price_last_minute: {
				title: 'Selling price for a subsequent booking',
				text: 'Enter the amount the article is offered for at the event including the margin (at least 20%) when it is ordered after the booking deadline.',
			},
			dependent_articles: {
				title: 'Dependent articles',
				text: 'If the article can only be used in combination with another product, that dependent article can be linked here.',
			},
			is_limited_in_time: {
				title: 'Individual period',
				text: 'States whether an individual period can be set when ordering the article. This option should be used for every article that is not available for the whole production period, e.g. cars, bicycles or plants.',
			},
			available_from: {
				title: 'Available from',
				text: 'States from when on the article can be booked, if it has an individual period.',
			},
			available_until: {
				title: 'Available until',
				text: 'States until when the article can be booked, if it has an individual period.',
			},
			order_notification: {
				title: 'Message when adding to the shopping cart',
				text: 'This setting can be used to show an individual message when the article is added to the shopping cart, e.g. that a driving licence is needed for a vehicle.',
			},
			order_description: {
				title: 'Requires order information',
				text: 'With this setting enabled the user has to fill in some information when adding the article to the shopping cart. What is to be filled in is entered here. The setting can be used e.g. for colour preferences.',
			},
			files: {
				title: 'Files',
				text: 'If additional files are to be provided to the orderer, they can be uploaded here.',
			},
			show_file_upload: {
				title: 'Enable file upload',
				text: 'States whether a dialog for uploading a file is shown when the article is added.',
			},
		},
		article_cart: {
			is_limited_in_time: {
				title: 'Limited availability',
				text: 'This article is not available for the whole production period. Click on the article to see its availability.',
			},
			dependent_articles: {
				title: 'Has dependent articles',
				text: 'This article needs further articles. Click on the article to see them.',
			},
			files: {
				title: 'Has files',
				text: 'Files have been added to this article. Click on the article to view or download them.',
			},
		},
		shop: {
			article_accepted: {
				title: 'Own article released for ordering',
				text: 'This own article has been released for ordering by the organizer.',
			},
			article_published: {
				title: 'Own article released for publication',
				text: 'This own article has been released for publication by your team and is waiting for the release by the organizer.',
			},
			article_pending: {
				title: 'Own article',
				text: 'This own article has not been released for publication yet.',
			},
		},
		cart: {
			name: {
				title: 'Purpose',
				text: 'The purpose should be filled in so several orders within one team can be told apart.',
			},
			location: {
				title: 'Location',
				text: 'The location is the position on the site where the ordered articles are needed. If no location can be selected, please get in touch with your contact person.',
			},
			required_from: {
				title: 'Arrival, start of use',
				text: 'The date states from when on articles without an individual period should be available at the location.',
			},
			required_until: {
				title: 'Departure, end of use',
				text: 'The date states until when articles without an individual period should be available at the location.',
			},
		},
		cart_item: {
			waiting_for_price: {
				title: 'Cart item is waiting for the price calculation',
				text: 'The price of the cart item is still being calculated by the seller.',
			},
			waiting_for_seller: {
				title: 'Cart item is waiting for the price to be accepted',
				text: 'The price of the cart item has been set. It still has to be accepted by the orderer.',
			},
			confirmed: {
				title: 'Cart item confirmed',
				text: 'The cart item has been confirmed as ordered.',
			},
			partially_confirmed: {
				title: 'Cart item confirmed with changes',
				text: 'The cart item could only be confirmed with changes.',
			},
			canceled: {
				title: 'Cart item canceled',
				text: 'The cart item has been canceled and cannot be realized.',
			},
			delivered: {
				title: 'Cart item delivered',
				text: 'Rows with a green background have already been delivered. The button with the truck marks an item as delivered.',
			},
		},
		event: {
			address: {
				title: 'Address data',
				text: 'Please enter the address of the event here. It is shown to the teams as the delivery address for the event.',
			},
		},
		team: {
			address: {
				title: 'Address data',
				text: 'Please enter the invoice address for your orders here, not the address of the event.',
			},
		},
		invite_team: {
			locations: {
				title: 'Delivery locations',
				text: 'Locations the team can order articles to.',
			},
			budget: {
				title: 'Budget',
				text: 'The maximum budget of the team. The total cost of all its orders cannot exceed this amount.',
			},
		},
	},
	confirms: {
		article_accept: {
			title: 'Release article for ordering',
			text: 'Release the article "{article_name}" for ordering? As soon as the article has been ordered, its settings can no longer be changed.',
		},
		article_publish: {
			title: 'Release article for publication',
			text: 'Release the article "{article_name}" for publication? As soon as the organizer has released the article, this cannot be undone.',
		},
		article_publish_info: {
			title: 'Info on publishing the article',
			text: 'The article "{article_name}" cannot be published. Please fill in all required information of the article.',
		},
		delete_article: {
			title: 'Delete article',
			text: 'Do you really want to remove the article "{name}"?',
		},
		remove_article_file: {
			title: 'Delete file of the article',
			text: 'Do you really want to remove the file "{name}"?',
		},
		order_cart: {
			title: 'Place a binding order',
			text: 'Place a binding order for the shopping cart "{name}" now?',
		},
		delete_cart_item: {
			title: 'Delete cart item',
			text: 'Do you really want to remove the item "{name}" from the shopping cart?',
		},
		confirm_cart_item: {
			title: 'Confirm cart item',
			text: 'Confirm the item "{name}"? This cannot be undone.',
		},
		refuse_cart_item: {
			title: 'Cancel cart item',
			text: 'Cancel the item "{name}"? This cannot be undone.',
		},
		deliver_cart_item: {
			title: 'Mark cart item as delivered',
			text: 'Mark the item "{name}" as delivered? Optionally a delivery note can be added.',
		},
		accept_pricing: {
			title: 'Accept the price on request',
			text: 'Accept the price of "{price}" for the article "{name}"? This cannot be undone.',
		},
		article_notification: {
			title: 'Article information',
		},
		add_dependend_articles: {
			title: 'Add dependent article',
			text: `The following articles are needed for the article "{name}". They are added automatically.`,
		},
	},
	filters: {
		article: 'Article',
		article_category: 'Article Category',
		article_publication: 'Article Completion',
		not_released: 'Not released for review',
		released_for_review: 'Released for review',
		not_published: 'incomplete',
		released_for_order: 'Released for ordering',

		seller: 'Seller',
		customer: 'Team',
		location: 'Location',

		order_state: {
			title: 'Order Status',
			value: {
				open: 'Open',
				ordered: 'Ordered',
				not_fully_confirmed: 'Not fully confirmed',
				fully_confirmed: 'Fully confirmed',
			},
		},
		cart_item_state: {
			title: 'Status',
			value: {
				open: 'Open',
				accepted: 'Confirmed',
				changed: 'Changed and confirmed',
				canceled: 'Canceled',
			},
		},
		delivery_state: {
			title: 'Delivery Status',
			value: {
				not_delivered: 'Not yet delivered',
				delivered: 'Delivered',
			},
		},
		delivery_confirmation: {
			title: 'Confirmation',
			value: {
				confirmed: 'Confirmed only',
				all: 'All',
			},
		},
	},
	notifications: {
		article_accepted: {
			icon: 'fa-check-double',
			title: 'Article released for ordering',
			text: "Your article '{article_name}' has been released for ordering by the organizer.",
		},
		order_created_to_buyer: {
			icon: 'fa-tasks',
			title: 'Order in progress',
			text: "Your order '{order_name}' has been received.",
		},
		order_created_to_seller: {
			icon: 'fa-tasks',
			title: 'Order received',
			text: "The order '{order_name}', containing articles you offer, has been created.",
		},
		cart_item_confirmed: {
			icon: 'fa-check',
			title: 'Cart item confirmed',
			text: "The cart item '{cart_item_article_name}' has been confirmed.",
		},
		cart_item_rejected: {
			icon: 'fa-times',
			title: 'Cart item refused',
			text: "The cart item '{cart_item_article_name}' has been refused.",
		},
		cart_item_article_added: {
			icon: 'fa-plus',
			title: 'Cart item added',
			text: "The cart item '{cart_item_article_name}' has been added.",
		},
		cart_item_article_switched: {
			icon: 'fa-arrow-up-arrow-down',
			title: 'Cart item switched',
			text: "The cart item '{cart_item_article_name}' has been switched for another article.",
		},
	},
	components: {
		occupied_days: {
			note: 'Something at the event lies on the days from {first} to {last} (articles, orders, order items). The dates have to include these days.',
		},
	},
};
